import "../../App.css";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { Table } from "antd";

export default function ClinicAddDoctor({
  embeddedClinicId,
  viewDoctorBasePath,
} = {}) {
  const navigate = useNavigate();
  const clinicId = embeddedClinicId ?? localStorage.getItem("clinicId");

  const [doctors, setDoctors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingDoctorId, setEditingDoctorId] = useState(null);
  const [form, setForm] = useState({
    doctorName: "",
    doctorEmail: "",
    doctorPassword: "",
    doctorTitle: "",
    doctorDegree: "",
    doctorMobile: "",
    ShowTransaction: 1,
  });
  const [addCertificateFile, setAddCertificateFile] = useState(null);
  const [editCertificateFile, setEditCertificateFile] = useState(null);

  const loadDoctors = () => {
    fetch(window.API_PREFIX + `admin/doctors_by_clinic?clinicId=${clinicId}`, {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/clinic");
          window.location.reload();
        } else if (data?.status === "1") {
          const list = (data?.doctors || []).map((d, i) => ({
            key: d.id || i,
            srNo: i + 1,
            ...d,
          }));
          setDoctors(list);
        } else {
          setDoctors([]);
        }
      })
      .catch(() => setDoctors([]));
  };

  useEffect(() => {
    if (!clinicId) return;
    loadDoctors();
  }, [clinicId]);

  const addDoctor = () => {
    if (!form.doctorName || !form.doctorEmail || !form.doctorPassword) {
      toast.error("Name, email, and password are required");
      return;
    }
    const fd = new FormData();
    fd.append("loginAs", localStorage.getItem("LoginDetails") || "");
    fd.append("clinicId", String(clinicId));
    fd.append("doctorName", form.doctorName);
    fd.append("doctorEmail", form.doctorEmail);
    fd.append("doctorPassword", form.doctorPassword);
    fd.append("doctorTitle", form.doctorTitle || "");
    fd.append("doctorDegree", form.doctorDegree || "");
    fd.append("doctorMobile", form.doctorMobile || "");
    fd.append("ShowTransaction", form.ShowTransaction ? "1" : "0");
    const recIdAdd = localStorage.getItem("receptionistId");
    if (recIdAdd) fd.append("receptionistId", recIdAdd);
    if (addCertificateFile) {
      fd.append("doctorDegreeCertificate", addCertificateFile);
    }
    fetch(window.API_PREFIX + "admin/add_clinic_doctor", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "1") {
          toast.success("Doctor added successfully");
          setForm({
            doctorName: "",
            doctorEmail: "",
            doctorPassword: "",
            doctorTitle: "",
            doctorDegree: "",
            doctorMobile: "",
            ShowTransaction: 1,
          });
          setAddCertificateFile(null);
          setIsModalOpen(false);
          loadDoctors();
        } else {
          toast.error(data?.message || "Could not add doctor");
        }
      })
      .catch(() => toast.error("Could not add doctor"));
  };

  const openEditModal = (doctor) => {
    setEditingDoctorId(doctor.id);
    setForm({
      doctorName: doctor.Name || "",
      doctorEmail: doctor.Email || "",
      doctorPassword: "",
      doctorTitle: doctor.Title || "",
      doctorDegree: doctor.Degree || "",
      doctorMobile: doctor.MobileNo || "",
      ShowTransaction: Number(doctor.ShowTransaction || 0) === 1 ? 1 : 0,
    });
    setEditCertificateFile(null);
    setIsEditModalOpen(true);
  };

  const editDoctor = () => {
    if (!editingDoctorId) return;
    if (!form.doctorName || !form.doctorEmail) {
      toast.error("Name and email are required");
      return;
    }
    const fd = new FormData();
    fd.append("doctorId", String(editingDoctorId));
    fd.append("doctorName", form.doctorName);
    fd.append("doctorEmail", form.doctorEmail);
    fd.append("doctorPassword", form.doctorPassword || "");
    fd.append("doctorTitle", form.doctorTitle || "");
    fd.append("doctorDegree", form.doctorDegree || "");
    fd.append("doctorMobile", form.doctorMobile || "");
    fd.append("ShowTransaction", form.ShowTransaction ? "1" : "0");
    fd.append("loginAs", localStorage.getItem("LoginDetails") || "");
    fd.append("clinicId", String(clinicId));
    const recId = localStorage.getItem("receptionistId");
    if (recId) fd.append("receptionistId", recId);
    if (editCertificateFile) {
      fd.append("doctorDegreeCertificate", editCertificateFile);
    }
    fetch(window.API_PREFIX + "admin/edit_clinic_doctor", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "1") {
          toast.success("Doctor updated successfully");
          setIsEditModalOpen(false);
          setEditingDoctorId(null);
          setEditCertificateFile(null);
          setForm({
            doctorName: "",
            doctorEmail: "",
            doctorPassword: "",
            doctorTitle: "",
            doctorDegree: "",
            doctorMobile: "",
            ShowTransaction: 1,
          });
          loadDoctors();
        } else {
          toast.error(data?.message || "Could not update doctor");
        }
      })
      .catch(() => toast.error("Could not update doctor"));
  };

  const deleteDoctor = (doctorId) => {
    if (!window.confirm("Are you sure you want to delete this doctor?")) return;
    fetch(window.API_PREFIX + "admin/delete_clinic_doctor", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        doctorId: doctorId,
        loginAs: localStorage.getItem("LoginDetails"),
        clinicId: clinicId,
        receptionistId: localStorage.getItem("receptionistId"),
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "1") {
          toast.success("Doctor deleted successfully");
          loadDoctors();
        } else {
          toast.error(data?.message || "Could not delete doctor");
        }
      })
      .catch(() => toast.error("Could not delete doctor"));
  };

  const columns = [
    { title: "Sr No", dataIndex: "srNo", key: "srNo", width: 90 },
    {
      title: "Doctor Name",
      key: "name",
      render: (_, r) => `${r.Title ? r.Title + " " : ""}${r.Name || ""}`,
    },
    { title: "Email", dataIndex: "Email", key: "Email" },
    { title: "Mobile", dataIndex: "MobileNo", key: "MobileNo" },
    { title: "Degree", dataIndex: "Degree", key: "Degree" },
    {
      title: "Certificate",
      key: "cert",
      render: (_, r) =>
        r.DegreeCertificateUrl ? (
          <a
            href={r.DegreeCertificateUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View
          </a>
        ) : (
          "—"
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, r) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-dark"
            onClick={() =>
              navigate(
                viewDoctorBasePath
                  ? `${viewDoctorBasePath}/${r.id}`
                  : `/clinic/view-doctor/${r.id}`,
              )
            }
          >
            View
          </button>
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => openEditModal(r)}
          >
            Edit
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => deleteDoctor(r.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  if (!clinicId) {
    return (
      <div className="container-fuild mx-2 mt-2">
        <p className="text-muted">No clinic selected.</p>
      </div>
    );
  }

  return (
    <div className="container-fuild mx-2 mt-2">
      <div className="d-flex justify-content-end">
        <button
          className="mitwank_patient_profile_add_prescription_btn"
          onClick={() => setIsModalOpen(true)}
        >
          + Add Doctor
        </button>
      </div>

      {isModalOpen && (
        <div
          id="myModal"
          className="modal"
          onClick={(e) => {
            if (e.target.id === "myModal") setIsModalOpen(false);
          }}
        >
          <div className="modal-content">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Add Doctor</h5>
              <i
                onClick={() => setIsModalOpen(false)}
                className="fa-solid fa-xmark fa-x close"
              ></i>
            </div>

            <div className="mt-3">
              <TextField
                label="Doctor Name"
                variant="outlined"
                size="small"
                className="w-100 mt-2"
                value={form.doctorName}
                onChange={(e) => setForm((p) => ({ ...p, doctorName: e.target.value }))}
              />
              <TextField
                label="Doctor Email"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorEmail}
                onChange={(e) => setForm((p) => ({ ...p, doctorEmail: e.target.value }))}
              />
              <TextField
                label="Doctor Mobile"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorMobile}
                onChange={(e) => setForm((p) => ({ ...p, doctorMobile: e.target.value }))}
              />
              <TextField
                label="Doctor Title"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorTitle}
                onChange={(e) => setForm((p) => ({ ...p, doctorTitle: e.target.value }))}
              />
              <TextField
                label="Doctor Degree"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorDegree}
                onChange={(e) => setForm((p) => ({ ...p, doctorDegree: e.target.value }))}
              />
              <TextField
                label="Create Password"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                type="password"
                value={form.doctorPassword}
                onChange={(e) => setForm((p) => ({ ...p, doctorPassword: e.target.value }))}
              />
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="addDoctorShowTransaction"
                  checked={Number(form.ShowTransaction) === 1}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      ShowTransaction: e.target.checked ? 1 : 0,
                    }))
                  }
                />
                <label className="form-check-label" htmlFor="addDoctorShowTransaction">
                  Show Transactions in Doctor Panel
                </label>
              </div>
              <div className="mt-3">
                <label className="form-label small fw-semibold">
                  Degree certificate (optional)
                </label>
                <input
                  type="file"
                  className="form-control form-control-sm"
                  accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*"
                  onChange={(e) =>
                    setAddCertificateFile(e.target.files?.[0] || null)
                  }
                />
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button type="button" className="popup_submit_button btn" onClick={addDoctor}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div
          id="editDoctorModal"
          className="modal"
          onClick={(e) => {
            if (e.target.id === "editDoctorModal") setIsEditModalOpen(false);
          }}
        >
          <div className="modal-content">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Edit Doctor</h5>
              <i
                onClick={() => setIsEditModalOpen(false)}
                className="fa-solid fa-xmark fa-x close"
              ></i>
            </div>

            <div className="mt-3">
              <TextField
                label="Doctor Name"
                variant="outlined"
                size="small"
                className="w-100 mt-2"
                value={form.doctorName}
                onChange={(e) => setForm((p) => ({ ...p, doctorName: e.target.value }))}
              />
              <TextField
                label="Doctor Email"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorEmail}
                onChange={(e) => setForm((p) => ({ ...p, doctorEmail: e.target.value }))}
              />
              <TextField
                label="Doctor Mobile"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorMobile}
                onChange={(e) => setForm((p) => ({ ...p, doctorMobile: e.target.value }))}
              />
              <TextField
                label="Doctor Title"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorTitle}
                onChange={(e) => setForm((p) => ({ ...p, doctorTitle: e.target.value }))}
              />
              <TextField
                label="Doctor Degree"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                value={form.doctorDegree}
                onChange={(e) => setForm((p) => ({ ...p, doctorDegree: e.target.value }))}
              />
              <TextField
                label="New Password (optional)"
                variant="outlined"
                size="small"
                className="w-100 mt-3"
                type="password"
                value={form.doctorPassword}
                onChange={(e) => setForm((p) => ({ ...p, doctorPassword: e.target.value }))}
              />
              <div className="form-check form-switch mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="editDoctorShowTransaction"
                  checked={Number(form.ShowTransaction) === 1}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      ShowTransaction: e.target.checked ? 1 : 0,
                    }))
                  }
                />
                <label className="form-check-label" htmlFor="editDoctorShowTransaction">
                  Show Transactions in Doctor Panel
                </label>
              </div>
              <div className="mt-3">
                <label className="form-label small fw-semibold">
                  Replace degree certificate (optional)
                </label>
                <input
                  type="file"
                  className="form-control form-control-sm"
                  accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*"
                  onChange={(e) =>
                    setEditCertificateFile(e.target.files?.[0] || null)
                  }
                />
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button type="button" className="popup_submit_button btn" onClick={editDoctor}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mitwank_patient_profile_table_division mt-3">
        <Table dataSource={doctors} columns={columns} pagination={{ pageSize: 10 }} />
      </div>
    </div>
  );
}

